// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FormDescriptionWidget .Widget_Label p {\n  font-weight: 300;\n  padding-bottom: 10px;\n  margin-bottom: 5px; }\n", ""]);
// Exports
module.exports = exports;
